package com.swetdot.swetgram.cache

import kotlin.Long
import kotlin.String

public data class CachedChat(
  public val id: String,
  public val kind: String,
  public val title: String?,
  public val avatarUrl: String?,
  public val unreadCount: Long,
  public val isMuted: Long,
  public val isArchived: Long,
  public val isPinned: Long,
  public val updatedAt: Long,
  public val changeCursor: String?,
)
